<template>
<div class="col backgroundForm">
        <div class="col col-md-10 offset-md-1">
        <div class="col col-md-6 offset-md-3">
            <div class="alert alert-danger" role="alert">
                <h4 class="alert-heading">Anexos de Orden de Operacion</h4>        
                <hr>
                <p v-if=" (cDtsUser.roleAssign !== 'OPERADOR' && cDtsUser.roleAssign !== 'FINANCIERO') "> Inclusion de Anexos a los resultados de las Unidades </p>
                <p v-else> Inclusion de Anexos a los resultados de la Unidad {{ cDtsUser.name_port | upper }}</p>
            </div>
        </div>
        <h6>Datos Generales</h6>
        <hr>
        
        <div class="form-row d-print-none">
            <div class="input-group mb-3 col-md-8 offset-md-2">
        
                <select class="form-control" name="year_ordop_a" id="year_ordop_a" v-model="year_select_a">
                    <option v-for="ya in years" :key="ya.c" :value="ya.c">{{ ya.c }}</option>
                </select>
                <select class="form-control" v-if="(cDtsUser.roleAssign !== 'OPERADOR' && cDtsUser.roleAssign !== 'FINANCIERO')" name="capitania_anexo" id="capitania_anexo" v-model="capitania_anexo" >
                    <option v-for="cpa in ports" :key=cpa.id :value="cpa">{{ cpa.name_port }}</option>
                </select>
                <div class="input-group-prepend" v-else>
                    <span class="input-group-text" id="">{{cDtsUser.name_port}}</span>
                </div>                
                <div class="input-group-append">
                    <button class="btn btn-outline-success" :disabled="animate_button" @click="mCallOrdops">
                        <font-awesome-icon icon="sync-alt" :spin="animate_button"/>
                    </button>            
                </div>
            </div>            
        </div>

        

        <h6>Detalles ORDOP</h6>
        <hr>
        <div class="form-row">
                        <transition name="fade" mode="out-in">
                            <div class="form-group col-12 col-md-6" v-if="ordops_init.length > 0">
                                <label for="ordop_init">Ordop Inicial</label>
                                <select class="form-control" name="ordop_ia" id="ordop_ia" v-model="ordop_master" @change="mCallResults">
                                    <option v-for="oi in ordops_init" :key="oi.id" :value="oi">{{ oi.detail }}</option>
                                </select>
                            </div>
                        </transition>
                        <transition name="fade" mode="out-in">
                            <div class="form-group col-12 col-md-6" v-if="ordops_result.length > 0">
                                <label for="ordop_result_a">Ordop Resultado</label>
                                <select class="form-control" name="ordop_result_a" id="ordop_result_a" v-model="ordop_result_select">
                                    <option v-for="or in ordops_result" :key="or.id" :value="or">{{ or.detail }} - {{ or.hecho }}</option>
                                </select>
                            </div>
                        </transition>
                    </div>
        
        
        <h6>Tipo Anexo</h6>
        <hr>
            <nav>
                <div class="nav nav-pills" id="nav-tab" role="tablist">
                    <a class="nav-item nav-link active" id="nav-init-traffic" data-toggle="tab" href="#nav-photo" role="tab" aria-controls="nav-home" aria-selected="true"> <font-awesome-icon icon="images" /> Fotografias </a>
                    <a class="nav-item nav-link" id="nav-second-traffic" data-toggle="tab" href="#nav-location" role="tab" aria-controls="nav-profile" aria-selected="false"><font-awesome-icon icon="compass" /> Geolocalizacion </a>
                    <a class="nav-item nav-link" id="nav-tirdh-traffic" data-toggle="tab" href="#nav-millas" role="tab" aria-controls="nav-profile" aria-selected="false"> <font-awesome-icon icon="route" /> Millas Navegadas </a>
                    <!-- <a class="nav-item nav-link" id="nav-tirdh-traffic" data-toggle="tab" href="#nav-doc" role="tab" aria-controls="nav-profile" aria-selected="false"> <font-awesome-icon icon="file-pdf" /> Informe Final </a> -->
                </div>
            </nav>
            <div class="tab-content" id="nav-tabContent">
                <br>            
                <div class="tab-pane fade show active"  id="nav-photo" role="tabpanel" aria-labelledby="nav-home-tab">
                    
                    <h6>Fotografia(s) del Resultado</h6>
                    <hr>
                    <div class="row">
                        <div class="col-12 col-md-6">
                            <div class="form-group">
                                <label for="titulo_photo">Titulo</label>
                                <input type="text" name="titulo_photo" id="titulo_photo" class="form-control" placeholder="Titulo Fotografia" v-model="photo_result.title">
                            </div>
                            <div class="form-group">
                                <label for="descriptio_photo">Descripcion</label>
                                <textarea name="descriptio_photo" id="descriptio_photo" class="form-control" placeholder="Descripcion de la Fotografia" v-model="photo_result.description" />
                            </div>
                        </div>
                        <div align="center" class="col-12 col-sm-4" id="imageOrdop">
                            <image-uploader
                            :preview="true"
                            :className="['fileinput' ,{ 'fileinput--loaded': hasImage }]"
                            capture="environment"
                            :debug="1"
                            doNotResize="[gif, jpg]"                            
                            :quality="qualityImage"
                            :autoRotate="true"
                            outputFormat="verbose"
                            @input="setImage"
                        >
                        
                            <label for="fileInput" slot="upload-label" class="col">
                            <div><font-awesome-icon icon="camera-retro" size="3x"></font-awesome-icon></div>
                            <span class="upload-caption">{{ hasImage ? "Cambiar" : "Seleccionar Foto Resultado" }}</span>
                            </label>
                            </image-uploader>
                        </div>
                    </div>
                    <button class="btn btn-success col-12 col-md-2 offset-md-5" v-if="cVerifyButtonPhoto" @click="mUploadPhotoAnexo"><font-awesome-icon icon="upload" size="2x" /></button>
                    
                </div>
                <!-- end photo  -->

                <div class="tab-pane fade"  id="nav-location" role="tabpanel" aria-labelledby="nav-home-tab">
                    
                    <h6>Geolocalizacion o Ubicacion del Resultado(Positivo)</h6>
                    <hr>
                    
                    <CargarMapa
                        :configMapa="configMapa"
                        apiKey="AIzaSyDQ4Ii0YR8i1LCRjgK9rfoDxVvE2S9__tU"
                    >

                        <template slot-scope="{ google, map }">
                        <NuevoMarcador
                            ref="newMark"
                            :marker=cNewLocation[0]
                            :google="google"
                            :map="map"
                        />
                        </template>

                    </CargarMapa>

                    <div class="form-row">
                        <label for="SectorLocation"><b>Sector o Localizacion</b></label>
                        <input type="text" class="form-control" name="SectorLocation" id="SectorLocation" autocomplete="off" v-model="location_result.sector">
                    </div>

                    <div class="form-row">
                        <label for="locationDescription"><b>Descripcion de la Ubicacion</b></label>
                        <textarea class="form-control" name="locationDescription" id="locationDescription" autocomplete="off" v-model="location_result.description" />
                    </div>
                    <br><br>
                    <button class="btn btn-success col-12 col-md-2 offset-md-5" v-if="cVerifyButtonSend" @click="mUploadLocation"><font-awesome-icon icon="sync-alt" size="2x" /></button>
                </div>
                <!-- end location  -->

                <div class="tab-pane fade"  id="nav-millas" role="tabpanel" aria-labelledby="nav-home-tab">
                    
                    <h6>Registro de las Millas Navegadas</h6>
                    <hr>
                    
                    <label for="bandera_embarcacion">Listado de Personal que participo en la ORDOP<span class="required-text">*</span></label>
                            <div class="table-responsive col-12">
                                <table class="table table-sm" v-if="millas_ordop_person.length > 0">
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Grado y Nombre</th>
                                            <th>Cargo o Rol</th>
                                            <th>Millas Navegadas</th>
                                            <th>Opciones</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(pso, index) in millas_ordop_person" :key="pso.personal_id">
                                            <td>{{ index+1 }}</td>
                                            <td>{{ pso.complete }}</td>
                                            <td>{{ pso.charge }}</td>
                                            <td>                    
                                                <div v-if="pso.is_save==='N'">
                                                    <div v-if="!pso.is_edit"> {{ pso.millas }} </div>                            
                                                    <input type="number" class="form-control col-md-8" v-else v-model="millas_temp.millas" min="0" />
                                                </div>
                                                <div v-else> {{ pso.millas }} </div>
                                            </td>
                                            <td>
                                                <div class="input-group mb-3" v-if="pso.is_save==='N'">
                                                    <div class="input-group-append" v-if="!pso.is_edit">
                                                        <button class="btn btn-outline-primary" type="button" @click="mEditPersonMilla(index)" ><font-awesome-icon icon="edit" /></button>
                                                    </div>
                                                
                                                    <div class="input-group-append" v-else>
                                                        <button class="btn btn-outline-success" type="button" @click="mSavePersonMilla(index)"><font-awesome-icon icon="save" /></button>
                                                        <button class="btn btn-outline-danger" type="button" @click="mCancelEditPersonMilla(index)"><font-awesome-icon icon="times-circle" /></button>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                    <br><br>
                    <button class="btn btn-success col-12 col-md-2 offset-md-5" v-if="millas_ordop_person.length > 0 && millas_ordop_person[0].is_save==='N'" @click="mUploadMillas"><font-awesome-icon icon="sync-alt" size="2x" /></button>

                </div>
                <!-- end millas navegadas -->
                <!-- <div class="tab-pane fade"  id="nav-doc" role="tabpanel" aria-labelledby="nav-home-tab">
                    
                    <h6>Envio de Informe Final Escaneado (PDF)</h6>
                    <hr>
                    
                </div> -->
                <!-- end location  -->

            </div>
        
        </div>
        <!-- <modal-loading :id-modal="idModalL" :title="modalLoadTitle" :status-send="sendRequest" ></modal-loading> -->
</div>  
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
const qs= require('qs');

import modalLoading from '../modal/modalLoading';

import CargarMapa from "../maps/LoadMap";
import Marcadores from "../maps/MarksMaps";
import NuevoMarcador from '../maps/NewMarkMap';

import { configMapa } from "@/constants/configMapa";

export default {
    name:'anexos-ordop',
    mounted(){
        this.mChargeInit();
        this.mVerifyCaptain();
    },
    data(){
        return{
            idModalL:'UploadPhotoOrdop',
            modalLoadTitle:'Subiendo',
            sendRequest:true,
            years:[],
            ports:[],
            year_select_a:0,
            capitania_anexo:{id:0},
            ordops_init:[],
            ordops_result:[],
            hasImage:false,
            scaleImage:0.5,
            qualityImage:0.9,            
            bImages:[],
            photo_result:{
                id:'',
                image:null,
                title:null,
                description:null
            },
            animate_button:false,
            ordop_master:{id:0},
            ordop_result_select:{id:0},
            location_result:{
                sector:null,
                description:null
            },
            millas_ordop_person:[],
            millas_temp:{id_person:0, indice:0, millas:0.0}
        }
    },
    methods:{
        mVerifyCaptain(){
            if(this.cDtsUser.roleAssign !== 'OPERADOR' && this.cDtsUser.roleAssign !== 'FINANCIERO'){
                this.capitania_anexo.id=0;
            }else{                
                this.capitania_anexo.id = this.cDtsUser.portId;
                this.capitania_anexo.name_port = this.cDtsUser.name_port;
            }
             
        },
        mValidateSendLocation(){
            if(this.location_result.sector===null || this.location_result.sector===''){
                toastr.warning('Indique el sector de ubicacion');
                return false;
            }
            if(this.location_result.description===null || this.location_result.description===''){
                toastr.warning('Indique la descripcion de la ubicacion');
                return false;
            }
            if(this.cNewLocationPosition.lat===null || this.cNewLocationPosition.lat===''){
                toastr.warning('Indique la posicion en el mapa');
                return false;
            }
            return true;
        },
        async mUploadLocation(){
            if(this.mValidateSendLocation()){
                let message = {
                        title: 'Geolocalizacion',
                        body: `¿Desea Registrar el punto de Georeferencia a <b>${this.ordop_result_select.detail}</b> de la ORDOP <b>${this.ordop_master.detail}</b> de la gestion <b>${this.year_select_a}</b> de la capitania <b>${this.capitania_anexo.name_port}</b>? <br><b>Nota:</b> una vez enviado el dato no se podra actualizar otro punto de georeferencia a este resultado`
                    }
                    
                    let npr=new Promise((resolve, reject)=>{
                        this.$dialog
                        .confirm(message)
                        .then(function(dialog) {
                            resolve(true);          
                        })
                        .catch(function() {
                            resolve(false);
                        });
                    });
                    
                    npr.then(async (msg)=>{
                        if(msg){
                            // subimos la fotografia
                            // this.mShowModalUP(this.idModalL);
                            try {
                                console.log(this.cNewLocationPosition)

                                let pos={
                                    lat:this.cNewLocationPosition.lat,
                                    lng:this.cNewLocationPosition.lng
                                }
                                let dtsLocation={
                                    id:this.ordop_result_select.id,
                                    position:JSON.stringify(pos),
                                    sector:this.location_result.sector,
                                    description:this.location_result.description
                                }

                                // console.log(dtsLocation);
                                let fd= await axios.post(`upLocationResultOrdop?api_token=${Vue.auth.getToken()}`, qs.stringify(dtsLocation));
                                    
                                if(fd.data[0].status){
                                    toastr.success(fd.data[0].respuesta, 'Exito');
                                
                                    this.location_result.sector=null;
                                    this.location_result.description=null; 
                                }else{
                                    toastr.error(fd.data[0].respuesta, 'Error');
                                }

                                                           

                            }catch(err){
                                console.log('error al registrar');
                                setTimeout(()=>{
                                    toastr.error('Ha ocurrido un error en el proceso', 'Error P-01')
                                    // this.mCloseModalUP(this.idModalL);                                
                                }, 3000)
                            }

                            setTimeout(()=>{                
                                        // this.mCloseModalUP(this.idModalL);
                            }, 1000)
                        }else{
                            console.log('No se guardo la ordop')
                            // console.log(this.s_pro_ordop);
                        }
                    })
            }else{
                console.error('no se envio al servidor los datos');
            }
        },  
        mValidateSendPhoto(){
            if(this.photo_result.title===null){
                toastr.warning('Indique el titulo de la Foto')
                return false;
            }
            if(this.photo_result.description===null){
                toastr.warning('Indique la descripcion de la Fotografia')
                return false;
            }
            return true;
        },
        async mUploadPhotoAnexo(){
            if(this.mValidateSendPhoto()){
                let message = {
                        title: 'Cargar Fotografia',
                        body: `¿Desea Añadir la fotografia al Resultado <b>${this.ordop_result_select.detail}</b> de la ORDOP <b>${this.ordop_master.detail}</b> de la gestion <b>${this.year_select_a}</b> de la capitania <b>${this.capitania_anexo.name_port}</b>?`
                    }
                    
                    let npr=new Promise((resolve, reject)=>{
                        this.$dialog
                        .confirm(message)
                        .then(function(dialog) {
                            resolve(true);          
                        })
                        .catch(function() {
                            resolve(false);
                        });
                    });
                    
                    npr.then(async (msg)=>{
                        if(msg){
                            // subimos la fotografia
                            // this.mShowModalUP(this.idModalL);
                            try {                                
                                let spo={
                                    id_ordop_result:this.ordop_result_select.id,
                                    image:this.photo_result.image,
                                    title:this.photo_result.title,
                                    description:this.photo_result.description
                                }
                                console.log(spo);
                                    // let fu= await axios.post(`upPhotoShip`, qs.stringify(sa));
                                let fd= await axios.post(`upPhotoResult?api_token=${Vue.auth.getToken()}`, qs.stringify(spo));
                                    
                                if(fd.data[0].status){
                                    toastr.success(fd.data[0].respuesta, 'Exito');
                                    this.photo_result.image=null;
                                    this.hasImage=false;
                                    document.getElementsByClassName('img-preview')[0].src='';
                                    this.photo_result.title=null;
                                    this.photo_result.description=null; 
                                }else{
                                    toastr.error(fd.data[0].respuesta, 'Error');
                                }

                                                           

                            }catch(err){
                                console.log('error al registrar');
                                setTimeout(()=>{
                                    toastr.error('Ha ocurrido un error en el proceso', 'Error P-01')
                                    // this.mCloseModalUP(this.idModalL);                                
                                }, 3000)
                            }

                            setTimeout(()=>{                
                                        // this.mCloseModalUP(this.idModalL);
                            }, 1000)
                        }else{
                            console.log('No se guardo la ordop')
                            // console.log(this.s_pro_ordop);
                        }
                    })
            }else{
                console.error('no se envio al servidor los datos');
            }
        },
        async mChargeInit(){
            // console.log(this.photo_result.image)
            let cp=await axios.get(`getPorts?api_token=${Vue.auth.getToken()}`);
            this.ports=cp.data;
            let ya=new Date();
            
            let year_select=ya.getFullYear();
            const init=2018;
            this.years=[];
            for(let i=init; i<=year_select; i++){
                let ai={c:i};
                this.years.push(ai);
            }
        },
        setImage(output){
            this.hasImage=true;
            this.photo_result.image=output.dataUrl;
            
            // console.log(this.ship.image);
        },
        mChangeGeneral(){
            this.ordops_init=[];
            this.ordops_result=[];
        },
        async mCallOrdops(){
            // verificar la categoria de 
            // limpiamos ambos resultados de las ordops
            this.animate_button=true;
            this.ordops_init=[];
            this.ordops_result=[];
            let idCap=(this.cDtsUser.roleAssign !== 'OPERADOR' && this.cDtsUser.roleAssign !== 'FINANCIERO') ? this.capitania_anexo.id : this.cDtsUser.portId;
            console.log(`${this.year_select_a} y ${idCap}`);
            if(this.year_select_a > 0 && idCap > 0 ){
                // obtenemos la ordop inicial
                let rsoi=await axios.get(`getOrdopsAnexo/${this.year_select_a}/${idCap}?api_token=${Vue.auth.getToken()}`);
                // console.log(rsoi);
                let dtsTemp=rsoi.data;
                this.animate_button=false;
                if(dtsTemp.length > 0){
                    this.ordops_init=dtsTemp;
                }else{
                    toastr.warning('No existe Ordops registradas', 'Informacion');
                }
                
            }else{
                // no cambiamos el resultado
                toastr.warning('Verifique que los campos de <b>Datos Generales</b> esten correctos', 'Advertencia');
            }           
        },
        async mUploadMillas(){
            
                let message = {
                        title: 'Millas Navegadas',
                        body: `¿Desea Registrar las Millas Navegadas de la ORDOP <b>${this.ordop_master.detail}</b> de la gestion <b>${this.year_select_a}</b> de la capitania <b>${this.capitania_anexo.name_port}</b>? <br><b>Nota:</b> una vez enviado los datos no se podra actualizar ni modificar las millas Navegadas`
                    }
                    
                    let npr=new Promise((resolve, reject)=>{
                        this.$dialog
                        .confirm(message)
                        .then(function(dialog) {
                            resolve(true);          
                        })
                        .catch(function() {
                            resolve(false);
                        });
                    });
                    
                    npr.then(async (msg)=>{
                        if(msg){
                            // subimos la fotografia
                            // this.mShowModalUP(this.idModalL);
                            try {
                                let dtsMillas={
                                    id:this.ordop_master.id,
                                    persons:JSON.stringify(this.millas_ordop_person)
                                }

                                // console.log(dtsLocation);
                                let fd= await axios.post(`upMillasOrdop/uc?api_token=${Vue.auth.getToken()}`, qs.stringify(dtsMillas));
                                    console.log(fd);
                                if(fd.data.status){
                                    toastr.success(fd.data.respuesta, 'Exito');

                                    this.callPersonsOrdop(); 
                                }else{
                                    toastr.error(fd.data.respuesta, 'Error');
                                }                                                        

                            }catch(err){
                                console.log('error al registrar');
                                setTimeout(()=>{
                                    toastr.error('Ha ocurrido un error en el proceso de registro', 'Error MN-01')
                                    // this.mCloseModalUP(this.idModalL);                                
                                }, 3000)
                            }

                            setTimeout(()=>{                
                                        // this.mCloseModalUP(this.idModalL);
                            }, 1000)
                        }else{
                            console.log('No se guardo las millas de la ordop')
                            // console.log(this.s_pro_ordop);
                        }
                    })
        },
        async callPersonsOrdop(){
            // aqui seleccionamos la ordop para incluir a mas personas
            this.millas_ordop_person=[];
            console.log('llamando a las personas de las ordops');
            // let data = this.ordop_select_persons     
            // aqui llamar los datos de las personas registradas
            let persons=await axios.get(`getOrdopPersonsFinish/${this.ordop_master.id}?api_token=${Vue.auth.getToken()}`);
            console.log(persons);
            persons.data.forEach(el=>{
                let aux_per_old={
                    complete:el.complete,
                    charge:el.charge,
                    id_person:el.id_person,
                    is_save:el.is_save,
                    is_edit:false,
                    millas:el.millas_navigate,
                };
                this.millas_ordop_person.push(aux_per_old);
            });
            // this.process_ordop_person.persons_old=persons.data;
        },
        mVerifyCampEditPersonMilla(){
            for(let key in this.millas_ordop_person){
                if( this.millas_ordop_person[key].is_edit ){
                     this.millas_ordop_person[key].is_edit=false;
                     this.millas_temp={};
                }
            }
        },
        mEditPersonMilla(index){
            // crear un temporal de edicion al momento de editar el temporal se debe llenar con los datos anteriores si se acepta la edicion se guarda y reemplaza, NO se mantiene el valor y se elimina el temporal, crear un id o key en cada registro dado que el codigo otros reeemplazara donde sea.
            // verificamos que no haya otro campo en edicion
            this.mVerifyCampEditPersonMilla();            
            this.millas_temp={
                id_person:this.millas_ordop_person[index].id_person,
                millas:this.millas_ordop_person[index].millas,
                indice:index
            }
            this.millas_ordop_person[index].is_edit=true;            
            
        },
        mSavePersonMilla(index){            
            // console.log(`terminando de editar el item ${index}`);
            if(this.millas_temp.millas >-1){

                if(this.millas_temp.indice===index){
                    this.millas_ordop_person[index].millas=this.millas_temp.millas;
                    this.millas_ordop_person[index].is_edit=false;
                    this.millas_temp={};
                    // this.mOrderListNews();
                }else{
                    toastr.warning(`Verifique la fila editada ${index+1}`);
                }
            }else{
                toastr.warning("Indique un valor mayor a -1 para su registro", "Millas navegadas");
            }
        },
        mCancelEditPersonMilla(index){
            this.millas_ordop_person[index].is_edit=false;
        },

        async mCallResults(){
            // llamamos a los resultados de las ordops
            if(this.ordop_master.id > 0){
                let ror=await axios.get(`getListDtsResult/${this.ordop_master.id}?api_token=${Vue.auth.getToken()}`);
                // console.log(ror);
                let tempResults=ror.data;
                if(tempResults.length > 0){
                    this.ordops_result=ror.data;
                    this.callPersonsOrdop();
                }else{
                    toastr.warning(`No existe Resultados registradas para la Ordop <b>${this.ordop_master.detail}</b>`, 'Informacion');
                }
                
            }else{
                toastr.warning('Seleccione una ordop Inicial', 'Advertencia');
            }
        },
        mShowModalUP(idM){
            $('#'+idM).modal('show');
        },
        mCloseModalUP(idM){
            $('#'+idM).modal('hide');
        },
    },
    computed:{
        cVerifyButtonSend(){
            let idCap=(this.cDtsUser.roleAssign !== 'OPERADOR' && this.cDtsUser.roleAssign !== 'FINANCIERO') ? this.capitania_anexo.id : this.cDtsUser.portId;
            if(this.year_select_a > 0 && this.capitania_anexo.id > 0 && this.ordop_master.id > 0 && this.ordop_result_select.id > 0){
                return true;
            }else{
                return false;
            }
        },
        cVerifyButtonPhoto(){            
            if(this.year_select_a > 0 && this.capitania_anexo.id > 0 && this.ordop_master.id > 0 && this.ordop_result_select.id > 0 && this.hasImage){
                return true;
            }else{
                return false;
            }
        },
        cDtsUser(){
            return this.$store.getters.getUserState;
        },
        configMapa() {
            return {
                ...configMapa,
                center: this.mapCenter
            };
        },
        cNewLocation(){
            // return this.$store.getters.getLocation;
            // console.log(this.$store.getters['sGoogleMaps/getLocation'].lat);
            return this.$store.getters['sGoogleMaps/getLocation'];
        },
        cNewLocationPosition(){
            return this.$store.getters['sGoogleMaps/getLocationPosition'];
        },
        mapCenter() {
            // return this.markers[0].position;
            return this.cNewLocation[0].position;
        }
    },
    components:{
        CargarMapa,
        Marcadores,
        NuevoMarcador
    },
    filters: {
        capitalize: function (value) {
            if (!value) return ''
            value = value.toString()
            value=value.toLowerCase();
            return value.charAt(0).toUpperCase() + value.slice(1)
        },
        upper: function (value) {
            if (!value) return ''
            value = value.toString()
            value=value.toUpperCase();
            return value.charAt(0).toUpperCase() + value.slice(1)
        }
    }
}
</script>

<style>
#imageOrdop img{
    width: 250px;
}
#fileInput {
  display: none;
}

</style>


// WEBPACK FOOTER //
// src/components/ordop/OrdopAnexo.vue